import { useQueryClient } from '@tanstack/react-query'

import type {
  DocCenterLiveEvent,
  DocumentEntryAddedEvent,
  DocumentEntryProcessedEvent,
} from '@fv/models'
import type { DTO } from '@fv/models/core'

import { queryKeys } from './api'
import type { DocCenterListItem } from './types'

export const useDocCenterLiveEventsHandler = () => {
  const queryClient = useQueryClient()

  const handleDocumentEntryAdded = (event: DTO<DocumentEntryAddedEvent>) => {
    queryClient.setQueryData<DocCenterListItem[]>(queryKeys.docs, prev => {
      const result = [...(prev ?? []), event.data.item]
      return result
    })
  }
  const handleDocEntryProcessed = (event: DTO<DocumentEntryProcessedEvent>) => {
    if (event.data.items.length === 0) return
    const entryId = event.data.items[0].entryId // all these should be the same
    // If the document has been processed, we could potentially show it with multiple loads, so we just remove the existing "processing" entry and replace it with the new "processed" entries
    queryClient.setQueryData<DocCenterListItem[]>(queryKeys.docs, prev => [
      ...(prev ?? []).filter(i => i.entryId !== entryId),
      ...event.data.items,
    ])
  }

  return (event: DTO<DocCenterLiveEvent>) => {
    if (event.eventType === 'doc-entry:added') {
      handleDocumentEntryAdded(event)
    } else if (event.eventType === 'doc-entry:processed') {
      handleDocEntryProcessed(event)
    }
  }
}
